import React, { useEffect, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'

/* container */
import ForgotPasswordContainer from '../../app-module-forgot-password-container/default'
/* container */

/* package */
import { ModPublicWrapp } from '../../lib-atomic-design-section'
import { GlobalContext, GlobalProvider } from '../../lib-atomic-context'
/* package */

/* form */
import ForgotPasswordForm from '../form/forgotpassword'
/* form */
import { GArecordPageView } from '../../lib-atomic-functions/google-analytics/ga-client'
import { useCookies } from 'react-cookie'

import CONFIG from '../config'

/* CONSTANTS */
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    // flexWrap: 'wrap',
    justifyContent: 'space-between',
    // overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
    paddingBottom: 80,
    maxWidth: 380,
    // minWidth: 300,
    margin: 'auto',
  },
  gridList: {
    width: 800,
  },
}))
const mediaPath = CONFIG.setup.assets.media
/* CONSTANTS */

const index = (props) => {
  // const [cookies, setCookie, removeCookie] = useCookies([
  //   'strictCookie',
  //   'performanceCookie',
  // ])
  const classes = useStyles()
  /* state */
  const { bannerscontents } = useContext(GlobalContext)
  const imgToDisplay = bannerscontents.state.data.masterbannerscontents.filter(
    (page) => {
      return page.pageName === 'ForgottenPassword'
    }
  )[0]
  /* state */
  useEffect(() => {
    // GArecordPageView(cookies)
  }, [])
  return (
    <ForgotPasswordContainer>
      <ModPublicWrapp {...props} imgToDisplay={imgToDisplay}>
        <div className={classes.root}>
          <ForgotPasswordForm {...props} />
        </div>
      </ModPublicWrapp>
    </ForgotPasswordContainer>
  )
}

export default index
